module.exports = __webpack_public_path__ + "images/rich_heading/home_appliance_furniture/furniture/icon_2328410d7c568391d7fa67ac261f4282.png";